import '@react-aria/interactions';
import { useLayoutEffect } from '@react-aria/utils';
import React__default, { useContext } from 'react';
import 'react-aria';
import 'react-dom';

var OverlayContext = /*#__PURE__*/React__default.createContext(null);

/** @private */
function useOverlayFocusContain() {
  var ctx = useContext(OverlayContext);
  var setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
  useLayoutEffect(function () {
    setContain === null || setContain === void 0 || setContain(true);
  }, [setContain]);
}

export { OverlayContext, useOverlayFocusContain };
//# sourceMappingURL=overlay.esm.js.map
